import { render, staticRenderFns } from "./FanGraphs.vue?vue&type=template&id=54a2375c&"
import script from "./FanGraphs.vue?vue&type=script&lang=js&"
export * from "./FanGraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports